export const NARRATIVEBOARDCONFIG = {
  NOCARDAVAILABLE: 'No card added to the narrative board.',
  NOCARDFOUND: 'No card found.',
  BUTTONTEXT: {
    REMOVECARD: 'Remove Card',
    SAVE: 'Save',
    DELETE: 'Delete',
    REPLY: 'Reply',
    CANCEL: 'Cancel',
  },
  INPUT: {
    CHOOSETEAM: 'Select Team',
    COMMENTPLACEHOLDER: 'Write your comment...'
  },
  DELETEMODELCONTENT: 'Are you sure you want to delete ?',
  DELETESUCCESSMESSAGE: 'Card is successfully removed from narrative board.',
  ACTION: {
    YES: 'Yes',
    NO: 'No',
  },
  SEARCH: 'Search...',
  COMMENT: {
    EDITWARNING: 'Do not have permission to edit others comment.',
    DELETEWARNING: 'Do not have permission to delete others comment.',
    VIEWMORECOMMENTS: 'View more comments',
    HIDEMORECOMMENTS: 'Hide comments',
    VIEWPREVIOUSCOMMENTS: 'View previous comments',
    VIEWMOREREPLIES: 'View more replies',
    HIDEMOREREPLIES: 'Hide replies',
  },
}